// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"40dfc980","453":"210abcff","455":"7b6c9fc1","977":"30fd7334"}[chunkId] + ".chunk.js";
};